module.exports = __webpack_public_path__ + "static/media/native-api-documentation.6188fe13.png";